module.exports = "<div class=\"login-wrapper\">\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/account/login/login.html
// module id = 402
// module chunks = 0